export const EARLY_ACCESS_VIP_SCOPE = "early_access_vip";

// Leaving this in case we want to show something for early adopters in the future, but for now we are not using it anywhere.
export const WAITLIST_PUBLIC_SCOPE = "wait_list_public";
export const WAITLIST_PRIVATE_SCOPE = "wait_list_private";
